import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import './index.css'; // Import your own CSS if you have any

const container = document.getElementById('root');
const root = createRoot(container);

root.render(<App />);
